import {
    IconShoppingBag, 
    IconReportAnalytics,
    IconHome2,
    IconReportMoney,
    IconGraphFilled,
    IconTypography,
    IconCopy,
    IconLogin,
    IconUserPlus,
    IconMoodHappy,
    IconAperture,
    IconUsers,
    IconPoint
} from '@tabler/icons-vue';
import img2 from '/images/svgs/icon-bars.svg';

export interface menu {
    header?: string;
    title?: string;
    icon?: any;
    to?: string;
    chip?: string;
    chipColor?: string;
    chipVariant?: string;
    chipIcon?: string;
    children?: menu[];
    disabled?: boolean;
    type?: string;
    subCaption?: string;
}

const sidebarItem: menu[] = [
    { header: 'Opciones' },
    {
        title: 'Inicio',
        icon: IconHome2,
        to: '/'
    },
    {
        icon: IconReportAnalytics,
        title: 'Products',
        to: '/admin/reports',
        children: [
            {
                title: "Catálogo",
                icon: IconPoint,
                to: "/apps/ecommerce/products",
            },
            {
                title: "Administración",
                icon: IconPoint,
                to: "/",
            }
        ]
    },
    // {
    //     title: "E-Commerce",
    //     icon: IconBasket,
    //     to: "/ecommerce/",
    //     children: [
    //       {
    //         title: "Shop",
    //         icon: PointIcon,
    //         to: "/apps/ecommerce/products",
    //       },
    //       {
    //         title: "Detail",
    //         icon: PointIcon,
    //         to: "/apps/ecommerce/product/detail/1",
    //       },
    //       {
    //         title: "List",
    //         icon: PointIcon,
    //         to: "/apps/ecommerce/productlist",
    //       },
    //       {
    //         title: "Checkout",
    //         icon: PointIcon,
    //         to: "/apps/ecommerce/checkout",
    //       },
    //     ],
    //   },
    // { header: 'utilities' },
    // {
    //     title: 'Typography',
    //     icon: IconTypography,
    //     to: '/ui/typography'
    // },
    // {
    //     title: 'Shadow',
    //     icon: IconCopy,
    //     to: '/ui/shadow'
    // },
    // { header: 'auth' },
    // {
    //     title: 'Login',
    //     icon: IconLogin,
    //     to: '/auth/login'
    // },
    // {
    //     title: 'Register',
    //     icon: IconUserPlus,
    //     to: '/auth/register'
    // },
    // { header: 'Extra' },
    // {
    //     title: 'Icons',
    //     icon: IconMoodHappy,
    //     to: '/icons'
    // },
    // {
    //     title: 'Sample Page',
    //     icon: IconAperture,
    //     to: '/sample-page'
    // },
    // { header: 'Test' },
    // {
    //     title: 'Users',
    //     icon: IconUsers,
    //     to: '/tests/users'
    // },
];

export default sidebarItem;
